export const DEF_Y_POS = {
    FULL_WIDTH: 11.5,
    HALF_WIDTH: 11.255,
};

export const POSITIONS_MAPS = {
    cornerTableMapPos: {
        right: {
            x: {
                1200: 0,
                1500: 0.15,
                1800: 0.3,
                2000: 0.4,
            },
            z: {
                500: -0.2,
                700: 0,
                900: 0.2,
                1500: 0.8,
            },
        },
        left: {
            x: {
                1200: -0.7,
                1500: -0.85,
                1800: -1,
                2000: -1.1,
            },
            z: {
                500: -0.2,
                700: 0,
                900: 0.2,
                1500: 0.8,
            },
        },
    },
    annexMapPos: {
        right: {
            x: {
                1000: -0.1,
                1200: 0,
                1500: 0.15,
                1800: 0.3,
                2000: 0.4,
            },
            z: {
                500: -0.2,
                600: -0.08,
                700: 0,
                900: 0.2,
                1500: 0.8,
            },
        },
        left: {
            x: {
                1000: 0.1,
                1200: 0,
                1500: -0.15,
                1800: -0.3,
                2000: -0.4,
            },
            z: {
                500: -0.2,
                600: -0.08,
                700: 0,
                900: 0.2,
                1500: 0.8,
            },
        },
    },
    podstavkaPodSistemniiBlokMapPos: {
        right: {
            x: {
                700: -0.25,
                900: -0.15,
                1000: -0.1,
                1200: 0,
                1500: 0.15,
                1800: 0.3,
                2000: 0.4,
            },
        },
        left: {
            x: {
                700: 0.25,
                900: 0.15,
                1000: 0.1,
                1200: 0,
                1500: -0.15,
                1800: -0.3,
                2000: -0.4,
            },
        },
    },
    panelElektromontazhnayaMapPos: {
        right: {
            x: {
                1200: 0.58,
                1500: 0.73,
                1800: 0.88,
                2000: 0.98,
            },
        },
    },
    upPositionMapPos: {
        right: {
            x: {
                700: -0.25,
                900: -0.15,
                1000: -0.1,
                1200: 0,
                1500: 0.15,
                1800: 0.3,
                2000: 0.4,
            },
        },
        left: {
            x: {
                700: 0.25,
                900: 0.15,
                1000: 0.1,
                1200: -0,
                1500: -0.15,
                1800: -0.3,
                2000: -0.4,
            },
        },
    },
    polkaDlyaKlavIMishiMapPos: {
        right: {
            x: {
                1000: 1.152 - 0.1,
                1200: 1.152,
                1500: 1.152 + 0.15,
                1800: 1.152 + 0.3,
                2000: 1.152 + 0.4,
            },
        },
        left: {
            x: {
                1000: 0.1,
                1200: 0,
                1500: -0.15,
                1800: -0.3,
                2000: -0.4,
            },
        },
    },
    ostrovPlacementMapPos: {
        front: {
            z: 0,
        },
        back: {
            z: 0,
        },
    },
    derzhatelRulonaBokovoiMapPos: {
        right: {
            x: {
                1200: 0,
                1500: 0.15,
                1800: 0.3,
                2000: 0.4,
            },
        },
        left: {
            x: {
                1200: 0,
                1500: -0.15,
                1800: -0.3,
                2000: -0.4,
            },
        },
    },
    verstak: {
        polka_dlya_klaviaturi: {
            left: {
                x: {
                    1200: 0,
                    1500: -0.15,
                    1800: -0.3,
                    2000: -0.4,
                },
                z: {
                    500: -0.2,
                    630: -0.108,
                    700: -0.13,
                    900: 0.2,
                },
            },
            right: {
                x: {
                    1200: 0,
                    1500: 0.15,
                    1800: 0.3,
                    2000: 0.4,
                },

                z: {
                    500: -0.2,
                    630: -0.108,
                    700: -0.13,
                    900: 0.2,
                },
            },
        },
    },
    derzhatelMonitoraSMK: {
        right: {
            x: {
                700: -0.238,
                900: -0.137,
            },
        },
        left: {
            x: {
                700: 0.238,
                900: 0.137,
            },
        },
    },
    verstakStoleshnitsaOffset: {
        y: 0.067,
    },
};

export const DEFAULT_Y_POS = 10;
